module.exports = __webpack_public_path__ + "img/event-atelier-ms-octobre-2024.4282eac.jpg";